import { io } from "socket.io-client";
import DecryptData from "../utils/Decrypt";

let socket = null;

function createSocket() {
  const BASE_SOCKET_URL = window.SOCKET_URL || window.BASE_SOCKET_SERVER_URL;
  const SOCKET_PATH = window.SOCKET_PATH;

  console.log("Initializing Socket with:", {
    BASE_SOCKET_URL,
    SOCKET_PATH,
    window_SOCKET_URL: window.SOCKET_URL,
    window_BASE_SOCKET_SERVER_URL: window.BASE_SOCKET_SERVER_URL,
    window_SOCKET_PATH: window.SOCKET_PATH,
    window_WEB_APP_API_URL: window.WEB_APP_API_URL,
  });

  if (!BASE_SOCKET_URL) {
    console.warn(
      "Socket URL is undefined. Socket might not connect to the correct server.",
    );
  }

  const userData = DecryptData("aTaDrEsU") || {};
  const userId = userData?.userId;

  console.log("User ID for socket:", userId);

  const socketOptions = {
    query: {
      app: "metascroll",
      user_id: userId,
      token: DecryptData("nEkOtResU"),
    },
    transports: ["websocket"],
    autoConnect: false,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 2000,
  };

  // Only add path if it is explicitly defined in config.js
  if (SOCKET_PATH) {
    socketOptions.path = SOCKET_PATH;
  }

  return io(BASE_SOCKET_URL, socketOptions);
}

export function getSocket() {
  if (!socket) {
    socket = createSocket();
  }
  return socket;
}

/** Tear down the current socket and clear the singleton (e.g. on logout) */
export function destroySocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
